import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Permission.api';

export const PermissionRequest = (permissionInputs) => ({
  type: actionTypes.PERMISSION_CREATE_REQUEST,
  payload: permissionInputs,
});
export const PermissionSuccess = (permission) => ({
  type: actionTypes.PERMISSION_CREATE_SUCCESS,
  payload: permission,
});

export const PermissionFailure = (error) => ({
  type: actionTypes.PERMISSION_CREATE_FAILURE,
  payload: error,
});

export const createPermission = (permissionInputs) => {
  return async (dispatch) => {
    dispatch(PermissionRequest(permissionInputs));
    try {
      const response = await api.createPermission(permissionInputs);

      if (response.status === 200) {
        dispatch(PermissionSuccess(response.data.permission));
        return {
          success: true,
          data: response.data,
        };
      } else {
        const message = response.data?.message || "Failed to create permission";
        dispatch(PermissionFailure(message));
        return {
          success: false,
          message,
        };
      }
    } catch (error) {
      const message =
        typeof error === "string" ? error : error.message || "An error occurred";
      dispatch(PermissionFailure(message));
      return {success: false, message,};
    }
  };
};

export const getPermissionRequest = () => ({
  type: actionTypes.PERMISSION_GET_REQUEST,
});

export const getPermissionSuccess = (permission) => ({
  type: actionTypes.PERMISSION_GET_SUCCESS,
  payload: permission,
});

export const getPermissionFailure = (error) => ({
  type: actionTypes.PERMISSION_GET_FAILURE,
  payload: error,
});

export const getPermission = () => {
  return async (dispatch) => {
    dispatch(getPermissionRequest());
    try {
      const permission = await api.fetchPermission();
      dispatch(getPermissionSuccess(permission));
      return { success: true, data: permission };
    } catch (error) {
      dispatch(getPermissionFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updatePermissionRequest = (id, stateData) => ({
  type: actionTypes.PERMISSION_UPDATE_REQUEST,
  payload: { id, stateData },
});

export const updatePermissionSuccess = (message) => ({
  type: actionTypes.PERMISSION_UPDATE_SUCCESS,
  payload: message,
});

export const updatePermissionFailure = (error) => ({
  type: actionTypes.PERMISSION_UPDATE_FAILURE,
  payload: error,
});

export const updatePermissionById = (id, stateData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    stateData.updated_by = user.user_name;  // Add the user name to the stateData

    dispatch(updatePermissionRequest(id, stateData));
    try {
      const response = await api.updatePermission(id, stateData);
      dispatch(updatePermissionSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updatePermissionFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deletePermissionRequest = (id) => ({
  type: actionTypes.PERMISSION_DELETE_REQUEST,
  payload: id,
});

export const deletePermissionSuccess = (message) => ({
  type: actionTypes.PERMISSION_DELETE_SUCCESS,
  payload: message,
});

export const deletePermissionFailure = (error) => ({
  type: actionTypes.PERMISSION_DELETE_FAILURE,
  payload: error,
});

export const deletePermissionById = (id) => {
  return async (dispatch) => {
    dispatch(deletePermissionRequest(id));
    try {
      const response = await api.deletePermission(id);
      dispatch(deletePermissionSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deletePermissionFailure(error));
      return { success: false, message: error };
    }
  };
};

export const AccessConfigurationRequest = (accessConfigurationInputs) => ({
  type: actionTypes.PERMISSION_CREATE_REQUEST,
  payload: accessConfigurationInputs,
});
export const AccessConfigurationSuccess = (accessConfiguration) => ({
  type: actionTypes.PERMISSION_CREATE_SUCCESS,
  payload: accessConfiguration,
});

export const AccessConfigurationFailure = (error) => ({
  type: actionTypes.PERMISSION_CREATE_FAILURE,
  payload: error,
});

export const createAccessConfiguration = (configurationInputs) => {
  return async (dispatch) => {
    dispatch(AccessConfigurationRequest(configurationInputs));
    try {
      const response = await api.access_configuration(configurationInputs);
      if (response.status === 200) {
        dispatch(AccessConfigurationSuccess(response.data.configuration));
        return { success: true };
      } else {
        dispatch(AccessConfigurationFailure(response.message || 'state input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(AccessConfigurationFailure(error.message || 'An error occurred'));
      return { success: false, message: error.message };
    }
  };
};







